import { useEffect, useRef } from "react";
import BeforeStartItem from "./BeforeStartItem";
import { useIntersectionObserver } from "../hooks/useIntersectionObserver";
import { useNavbar } from "../context/NavbarContext";
import { MENU_SECTION_ENUM } from "../utils/enums";

export default function BeforeStart() {
  const { setActiveSection } = useNavbar();
  const sectionRef = useRef(null);
  const sectionObserver = useIntersectionObserver(sectionRef);

  useEffect(() => {
    if (sectionObserver?.isIntersecting) {
      setActiveSection(MENU_SECTION_ENUM.BEFORE_START);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionObserver]);

  return (
    <section
      className="xpb-before-start"
      id="xpb-before-start"
      ref={sectionRef}
    >
      <div className="xpb-before-start__title">
        <h3>
          Antes de <br />
          empezar
        </h3>
        <h4>
          Algunos aspectos <br />a considerar:
        </h4>
      </div>
      <ul>
        <BeforeStartItem
          number={1}
          title={"¿A QUIÉN ESTÁ DIRIGIDA LA ESTRATEGIA DE COMUNICACIÓN?"}
          text={
            "La audiencia objetivo es la poblacion que tiene sentimientos encontrados respecto a la migración: ni muy a favor ni muy en contra."
          }
        />
        <BeforeStartItem
          number={2}
          title={"¿CUÁL ES EL MENSAJE?"}
          text={
            "La integración ya está sucediendo. Se deben identificar historias reales con protagonistas y lugares auténticos para construir los mensajes a partir de la realidad local."
          }
        />
        <BeforeStartItem
          number={3}
          title={"¿QUIÉN TIENE QUE EMITIR EL MENSAJE?"}
          text={
            "Complementar los canales institucionales con voceras, voceros y canales alternativos para lograr un mayor alcance y efectividad."
          }
        />
        <BeforeStartItem
          number={4}
          title={"¿CUÁNTO DEBERÍA DURAR UNA ESTRATEGIA DE COMUNICACIÓN?"}
          text={
            "Transformar creencias lleva tiempo: se necesitan estrategias de comunicación de largo plazo que conecten las campañas puntuales -las que tienen un comienzo y un fin- de forma continua."
          }
        />
        <BeforeStartItem
          number={5}
          title={"¿CÓMO SABER SU EFECTIVIDAD?"}
          text={
            "Una campaña funciona cuando penetra positivamente en la conversación pública: es decir, cuando la gente común habla."
          }
        />
      </ul>
    </section>
  );
}
